export default {
  namespaced: true,
  state: {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key
    baiDuMap: {
      ak: "ksZ6kPDGVce8xRdA7KCUz9Sm60cRY7ib"
    },
    
    // 请求地址
    baseURL: "https://school.zzsasoft.com/api",       //学校正式
    // playBaseURL: "https://school.zzsasoft.com/gb-api",         //学校正式
    baseURLJinShui: "https://school.zzsasoft.com/gw",     //正式
    baseURLFenYin: "https://api.g2.aibabel.cn/babel",     //正式
    baseURLUpload: "https://school.zzsasoft.com/cup",     //正式
    // 答题二维码
    base: "https://school.zzsasoft.com/mobileWeb/#/test", //学校正式
    // websocket 请求地址
    wsIpConfig: "wss://school.zzsasoft.com/sendMessage", //学校正式 wss

    
    // // // 当前文件配置
    fileUrl: "https://school.zzsasoft.com/uploads/",  // 学校正式



    // baseURL: "http://192.168.1.27/api",     //测试
    // playBaseURL: "http://192.168.1.27/gb-api",         //测试
    // baseURLJinShui: "http://192.168.1.27/gw",         //测试
    // baseURLFenYin: "https://api.g2.aibabel.cn/babel",         //测试
    // baseURLUpload: "https://api.g2.aibabel.cn/babel",         //测试
    // fileUrl: "http://192.168.1.149/uploads/",          // 测试
    // wsIpConfig: "ws://192.168.1.27:8083/shuangan",       //测试
    // base: "http://192.168.1.27/mobileWeb/#/test",   //测试
    // wsIpConfig: "wss://192.168.1.27/mobileWeb/sendMessage", //测试 wss


    // baseURL: "http://192.168.1.128:8083/shuangan",    //龙飞本地
    // playBaseURL: "/dev-api",    //龙飞本地
    // // playBaseURL: "http://192.168.1.128:6666/gb-api",    //龙飞本地
    // baseURLJinShui: "http://192.168.1.128:8086/",     //龙飞本地
    // baseURLFenYin: "http://192.168.1.128:8086/",     //龙飞本地
    // baseURLUpload: "http://192.168.1.128:8999/cos/v1",     //龙飞本地
    // wsIpConfig: "ws://192.168.1.33:8083/shuangan",      //龙飞本地


    // // fileUrl: "http://192.168.1.33/uploads/",         // 龙飞本地


    // baseURL: "http://192.168.1.185:8083/shuangan",    //威威本地
    // baseURL: "https://safe.zzsasoft.com/api",         //企业正式
    // fileUrl: "http://192.168.1.185/uploads/",         // 威威本地
    // fileUrl: "https://safe.zzsasoft.com/uploads/",    // 企业正式

    //base: "https://safe.zzsasoft.com/mobileWeb/#/test", //企业正式

    // wsIpConfig: "ws://192.168.1.185:8083/shuangan",      //威威本地
    // wsIpConfig: "wss://safe.zzsasoft.com/sendMessage"   //企业正式
  },
  mutations: {},
  actions: {},
  getters: {}
};
